// NOTE: This file is used by both the browser and NodeJS tooling code of this repo.
//       Please keep this file free of code tying it to either environment.

export type Env = typeof process.env;

export const getEnvVar = (env: Env, key: string): string => {
  const value = env[key];
  if (!value) {
    throw new Error(
      [
        `The env var "${key}" could not be found.`,
        "Please make sure you are using",
        'the recommended tooling provided by "@fabric/core/lib/tooling".',
      ].join(" "),
    );
  }
  return value;
};

export const getJsonEnvVar = <T>(env: Env, key: string): T => {
  const value = getEnvVar(env, key);
  const parsedValue: T = JSON.parse(value);
  return parsedValue;
};

export const getAppName = (env: Env): string => {
  try {
    return getEnvVar(env, "REACT_APP_OVERRIDE_NAME");
  } catch (e1) {
    try {
      return getEnvVar(env, "REACT_APP_NAME");
    } catch (e2) {
      return getEnvVar(env, "REACT_APP_PACKAGE_JSON_NAME");
    }
  }

  // Uncomment once all apps & container are running core 1.0.80
  // try {
  //   return getEnvVar(env, "REACT_APP_NAME");
  // } catch (e) {
  //   return getEnvVar(env, "REACT_APP_PACKAGE_JSON_NAME");
  // }
};

export const getIsRunningInContainer = (): boolean => {
  return getAppName(process.env) === "container";
};

export const ensureCanAccessSharedFabricCore = (fnName: string): void => {
  const isInBuildTooling = !global.window;
  if (isInBuildTooling && !getIsRunningInContainer()) {
    throw new Error(
      `Cannot call ${fnName} outside the browser as the data required for this is not available at build time.`,
    );
  }
};
